/**
 * @generated SignedSource<<41c9275a4bfe32c32cea305daf6f41b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchPassionfruitAsk_AtlassianSearchPage$data = {
  readonly __typename: string;
  readonly id: string;
  readonly lastModifiedDate?: string | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"searchPassionfruitAskStatusTargetDate_AtlassianSearchPage">;
  readonly " $fragmentType": "searchPassionfruitAsk_AtlassianSearchPage";
};
export type searchPassionfruitAsk_AtlassianSearchPage$key = {
  readonly " $data"?: searchPassionfruitAsk_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchPassionfruitAsk_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchPassionfruitAsk_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "searchPassionfruitAskStatusTargetDate_AtlassianSearchPage"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        }
      ],
      "type": "SearchResultSpfAsk"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};

(node as any).hash = "3d4f5d6c4a2884dde22ba42bee1c8825";

export default node;
